// Copyright (c) 2023 WiseTime. All rights reserved.

import React, { forwardRef } from "react"
import styled, { css } from "styled-components/macro"
import SvgIcon from "features/shared/SvgIcon"

const Button = styled.button<{ $isActive: boolean }>`
  font-size: 1.5rem;
  color: ${({ theme }): string => theme.colors.dimGray};
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 3px;
  transition: all .3s ease;

  &:hover {
    color: ${({ theme }): string => theme.colors.indigo};
    background-color: ${({ theme }): string => theme.colors.lavender};
  }

  ${({ theme, $isActive }) => $isActive && css`
    color: ${theme.colors.indigo};
    background-color: ${theme.colors.lavender};
  `}
`

const StyledIcon = styled(SvgIcon)`
  width: 15px;
  min-width: 15px;
  height: 15px;
  vertical-align: -2px;
`

type Props = {
  iconName: string,
  title: string,
  isActive?: boolean,
  className?: string,
  tabIndex?: number,
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

const ActionPaneIcon = forwardRef<HTMLButtonElement, Props>(({
  iconName,
  title,
  isActive = false,
  className,
  tabIndex = 0,
  onClick,
}, ref): React.ReactElement<Props> => (
  <Button
    ref={ref}
    onClick={onClick}
    title={title}
    tabIndex={tabIndex}
    $isActive={isActive}
    className={className}
  >
    <StyledIcon name={iconName}/>
  </Button>
))

export default ActionPaneIcon
